// src/constants/PatientViewFilters.js

const SupportViewFilters = {
  default: [
    {
      label: "Status",
      key: "isactive",
      options: ["Active", "Inactive", "Pending", "Completed"],
    },
    {
      label: "Gender",
      key: "gender",
      options: ["Male", "Female", "Other"],
    },
  ],
 
  additional: [
       {
      label: "Age",
      key: "age",
      options: ["0-18", "19-35", "36-60", "60-75", "75-100"],
      operator: "Between",
      inputType: "single-select",
    },
    {
      label: "Allergies",
      key: "allergies",
      options: ["Peanuts", "Gluten", "Lactose", "Pollen"],
    },
    {
      label: "Blood Group",
      key: "blood_group",
      options: ["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"],
    },
    {
      label: "Date",
      key: "insertedDate",
      operator: "Between",
      inputType: "date-range",
    },
  ]
};

export default SupportViewFilters;
